//import projects
import Template from './Template';
import prompts from '../../../dummy_data/prompt_engineer/business.json';

// External variant
const options = [
    'Đạt doanh số',
    'Khuyến khích khách mua hàng',
    'Phát triển kênh bán hàng',
    'Tạo nội dung hấp dẫn',
    'Lập bản đồ hành trình khách hàng',
    'Dùng phản hồi và đánh giá của khách',
    'Tạo sự cấp bách'
];

const prompt_persona_role =
    'Phản hồi như một chuyên gia kinh doanh, giúp tạo ra các chiến lược kinh doanh hiệu quả, phát triển và duy trì sự tăng trưởng lâu dài.';

export default function Business() {
    return (
        <Template
            personaRole={prompt_persona_role}
            data={prompts}
            title="Kinh doanh"
            options={options}
            project="prompt_engineer/business"
        />
    );
}
